// 全局项目信息，因为很多菜单功能是基于项目信息的
export const CACHE_PROJECT_ID = 'CACHE_PROJECT_ID'
export const CACHE_PROJECT_NAME = 'CACHE_PROJECT_NAME'
export const CACHE_IS_PAD = 'CACHE_IS_PAD'
export const PUBLIC_KEY='MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEAt0CBmG6znFAOpA7EJx5fPIgBwWh8ElRdHwBwOJAfBipiz1pwrNZhsGTkdd00lt+6k7gbIw+LAyQ02Y/2ctyvhLuAmLjJnQqQSd9e1qCTx/HKax6ZT/0mJ2tvbhgGcQfN8Gs6ZCJ/VaJfuL4vPwRA6p0pW8vpav/jwscagN8VyuOmqG92SLodWSsDMD7R8Kmo+osb/PjV3EFArqLfHz9+DWc2Ui65Koa1zQ8Iyl6W2HF40ohamuB+x2Bjsr0uLEkNaoe/jh/83KxuZHqRP1jwhA+FcdBJO0MloVGW0/IleRh2jr0xrPHi/JjYfePCDPkWYl5bImYytQ9VbsjefTU/KQIDAQAB'

export const statusData = {
  '1':{
    text:'新建',
    color:'purple'
  },
  '2':{
    text:'未开始',
    color:'blue'
  },
  '3':{
    text:'进行中',
    color:'cyan'
  },
  '4':{
    text:'暂停',
    color:'orange'
  },
  '5':{
    text:'终止',
    color:'red'
  },
  '6':{
    text:'完成',
    color:'green'
  }
}
export const elementTypeData={
  text:{
    text:'文本',
    value:'text'
  },
  textarea:{
    text:'大文本',
    value:'textarea'
  },
  number:{
    text:'数字',
    value:'number'
  },
  dateTime:{
    text:'时间',
    value:'dateTime'
  },
  select:{
    text:'单选',
    value:'select'
  },
  check:{
    text:'复选',
    value:'check'
  },
  date:{
    text:'日期',
    value:'date'
  },
  dateyear:{
    text:'年月',
    value:'dateyear'
  },
  time:{
    text:'时分',
    value:'time'
  },
  hour:{
    text:'时分秒',
    value:'hour'
  },
  minute:{
    text:'分秒',
    value:'minute'
  },
  qrCode:{
    text:'扫码',
    value:'qrCode'
  },
  file:{
    text:'文件上传',
    value:'file'
  },
  slider:{
    text:'滑动条',
    value:'slider'
  },
   table:{
    text:'表格',
    value:'table'
  },
}

export const cascadeData = {
  date2days:{
    text:'计算指定日期到当前时间的天数',
    value: 'date2days'
  },
  date2years:{
    text:'计算指定日期到当前时间的年数',
    value: 'date2years'
  },
  years2Date:{
    text:'计算当前时间减去指定年数的具体年份',
    value: 'years2Date'
  }
}